var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SimpleInstance } from './instance';
/**
 * @description Build an k/v object from the custom storage integration
 */
export const BuildStorageObjectFromCustom = (data, storage) => __awaiter(void 0, void 0, void 0, function* () {
    let newObj = {};
    for (let item of Object.entries(data)) {
        newObj[item[0]] = yield storage.get(item[0]);
    }
    return newObj;
});
/**
 * @description Build an object with k/v from the window.localstorage and we need to parse if its not undefined
 */
export const parseWindowLocalStorageToMap = (data) => {
    let newObj = {};
    for (let item of Object.entries(data)) {
        if (window.localStorage[SimpleInstance().storage._prefixKey + item[0]] === undefined) {
            newObj[item[0]] = undefined;
        }
        else {
            newObj[item[0]] = JSON.parse(window.localStorage[SimpleInstance().storage._prefixKey + item[0]]);
        }
    }
    return newObj;
};
export const makeid = (length) => {
    let result = '';
    let characters = '0123456789';
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};
//# sourceMappingURL=utils.js.map